import React, { useState, useEffect } from 'react';
import { TableContainer, Paper, Table, TableHead, TableBody, TableRow, TableCell, useMediaQuery, Backdrop, CircularProgress } from '@mui/material';
import { Card, Button, Collapse } from 'antd';
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";
import { BASE_URL } from '../../App';
import Swal from 'sweetalert2';

const { Panel } = Collapse;

const ServiceClaimPending = () => {
  const [serviceClaimPending, setServiceClaimPending] = useState([]);
  const [serviceClaimRejected, setServiceClaimRejected] = useState([]);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)'); // detect screen size

  useEffect(() => {
    if (!queryParams.get('LOGIN_ID')) {
      const login_id = localStorage.getItem("LOGIN_ID");
      ServiceClaimepending(login_id);
    } else {
      const login_id1 = queryParams.get('LOGIN_ID');
      axios.post(BASE_URL + "/getloginidEncode", { login_id: login_id1 })
        .then((response) => {
          const login_id = response.data.login_id;
          ServiceClaimepending(login_id);
        })
        .catch(() => {
          Swal.fire('Error', 'LOGIN_ID NOT DECRIPTED', 'error');
        });
    }
  }, []);

  const ServiceClaimepending = (login_id) => {
    setOpen(true);
    const formData = new FormData();
    formData.append('login_id', login_id);
    formData.append('assigned_to', login_id);

    axios.post(BASE_URL + "/Serviceclaimpending_claime", formData)
      .then((response) => {
        setServiceClaimPending(response.data.service_claim[0].service_claim_pending);
        setServiceClaimRejected(response.data.service_claim[0].service_claim_rejected);
        setOpen(false);
      })
      .catch((error) => {
        Swal.fire('No Data', error.response?.data?.message?.[0] || "Error", 'error');
        setOpen(false);
      });
  };

  const handleClaimClick = async (token, serial, itemCode, isPending, doc_number) => {
    let login_id;
    let BRANCH_CODE1;

    if (!queryParams.get('LOGIN_ID')) {
      login_id = localStorage.getItem("LOGIN_ID");
    } else {
      const login_id1 = queryParams.get('LOGIN_ID');
      await axios.post(BASE_URL + "/getloginidEncode", { login_id: login_id1 })
        .then((response) => {
          login_id = response.data.login_id;
        });
    }

    if (!queryParams.get('BRANCH_CODE')) {
      BRANCH_CODE1 = localStorage.getItem("BRANCH_CODE");
    } else {
      const BRANCH_CODE = queryParams.get('BRANCH_CODE');
      await axios.post(BASE_URL + "/getBranchEncode", { BRANCH_CODE })
        .then((response) => {
          BRANCH_CODE1 = response.data.BRANCH_CODE;
        });
    }

    const status = isPending ? 'claim' : 'rejected';
    const data = { Token_no: token, Serial_no: serial, Item_code: itemCode, Pending: status, login_id, BRANCH_CODE: BRANCH_CODE1, doc_number };

    if (status === 'rejected') {
      navigate('/Home/services/service_claim_reject_claim', { state: data });
    } else {
      navigate('/Home/services/service_claim_pending_claim', { state: data });
    }
  };

  const renderTable = (data, isPending) => {
    if (data.length === 0) {
      return (
        <div className='row'>
          <div className='col-md-12 shadow-none p-3 mb-5 bg-light rounded'>
            <div className='text-center'>
              <h6><b>No Records Found</b></h6>
            </div>
          </div>
        </div>
      );
    }

    const keys = Object.keys(data[0]);

    // Mobile view → Collapse cards
    if (isMobile) {
      return (
        <Collapse accordion>
          {data.map((row, index) => {
            const token = row.TOKEN_NUMBER;
            const serial = row.SERIAL_NO;
            const itemCode = row.MAT_CODE || row.ITEM_CODE;
            const doc_number = row.DOC_NO;

            return (
              <Panel header={
              <div>
                Token: <span style={{ fontWeight: '600' }}>{token}</span> &nbsp; | &nbsp; Serial: <span style={{ fontWeight: '600' }}>{serial}</span>
              </div>
               } key={index}>
                {keys.map((key) => (
                  <p key={key}><span style={{ fontWeight: '600' }}>{key.replace(/_/g, ' ')}:</span> {row[key]}</p>
                ))}
                <Button
                  onClick={() => handleClaimClick(token, serial, itemCode, isPending, doc_number)}
                  style={{ width: '100%', marginTop: '10px', borderRadius: '3px', color: '#fff', backgroundColor: '#28a745' }}
                >
                  {isPending ? 'Claim' : 'Rejected Claim'}
                </Button>
              </Panel>
            );
          })}
        </Collapse>
      );
    }

    // Desktop view → Table
    return (
      <TableContainer component={Paper} style={{ maxHeight: '400px', overflowY: 'scroll' }}>
        <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ padding: '5px', background: 'rgb(31 78 215)', color: 'white', textAlign: 'center' }}>Action</TableCell>
              {keys.map((key) => (
                <TableCell key={key} style={{ padding: '5px', background: 'rgb(31 78 215)', color: 'white', textAlign: 'center' }}>
                  {key.replace(/_/g, ' ')}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => {
              const token = row.TOKEN_NUMBER;
              const serial = row.SERIAL_NO;
              const itemCode = row.MAT_CODE || row.ITEM_CODE;
              const doc_number = row.DOC_NO;

              return (
                <TableRow key={index}>
                  <TableCell style={{ padding: '10px', background: '#e3fafe' }}>
                    <Button
                      onClick={() => handleClaimClick(token, serial, itemCode, isPending, doc_number)}
                      style={{ width: '100%', borderRadius: '3px', color: '#fff', backgroundColor: '#28a745' }}
                    >
                      {isPending ? 'Claim' : 'Rejected Claim'}
                    </Button>
                  </TableCell>
                  {keys.map((key) => (
                    <TableCell key={key} style={{ padding: '10px', background: '#e3fafe' }}>
                      {row[key]}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <div>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', background: '#61d1e5', color: 'black' }}>
        <h5><b>Pending Service Claim Details</b></h5>
      </Card>
      <br />
      {renderTable(serviceClaimPending, true)}

      <br />
      <Card className="shadow rounded" style={{ width: '100%', height: '60px', fontWeight: 'bold', background: '#61d1e5', color: 'black' }}>
        <h5><b>Rejected Claim Details</b></h5>
      </Card>
      <br />
      {renderTable(serviceClaimRejected, false)}
    </div>
  );
};

export default ServiceClaimPending;
